import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';
import { AnimatedBgComponent } from "../../../shared/animated/animated-bg.component";

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [RouterLink, AnimatedBgComponent, NgFor],
  template: `
    <section class="hero">
      <app-animated-bg></app-animated-bg>
      <div class="hero__bg" aria-hidden="true"></div>

      <div class="container hero__grid">
        <div class="hero__copy">
          <p class="pill">DATA ENGINEERING • BI • IA & AUTOMATISATION</p>

          <h1 class="h1">Des données fiables.<br/>Des décisions rapides.</h1>

          <p class="lead">
            Chez <b>Data BI Solutions</b>, nous aidons les entreprises à transformer leurs données en décisions concrètes et rentables.
            Notre mission : structurer, analyser et valoriser vos données pour en faire un véritable levier de performance.
          </p>

          <div class="actions">
            <a class="btn primary" routerLink="/contact">Demander un audit</a>
            <a class="btn ghost" href="#expertises">Nos expertises</a>
          </div>

          <div class="kpis">
            <div class="kpi">
              <div class="kpi__top"><span class="kpi__icon">👥</span><b>+50</b></div>
              <div class="kpi__lab">Clients</div>
            </div>

            <div class="kpi">
              <div class="kpi__top"><span class="kpi__icon">🗂️</span><b>+120</b></div>
              <div class="kpi__lab">Projets</div>
            </div>

            <div class="kpi">
              <div class="kpi__top"><span class="kpi__icon">📈</span><b>+25%</b></div>
              <div class="kpi__lab">ROI moyen</div>
            </div>

            <div class="kpi">
              <div class="kpi__top"><span class="kpi__icon">✅</span><b>99%</b></div>
              <div class="kpi__lab">Qualité data</div>
            </div>
          </div>
        </div>

        <!-- Dashboard visual (hidden on tablet/phone) -->
        <div class="hero__visual">
          <div class="frame">
            <div class="mock">
              <div class="mock__top">
                <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span>
                <span class="mock__title">Executive Dashboard</span>
              </div>

              <div class="mock__body">
                <div class="dkpi">
                  <span>Revenue</span><b>€1.42M</b><i class="up">▲ 8.3%</i>
                </div>
                <div class="dkpi">
                  <span>CAC</span><b>€118</b><i class="down">▼ 3.1%</i>
                </div>
                <div class="dkpi">
                  <span>Retention</span><b>92%</b><i class="up">▲ 1.4%</i>
                </div>

                <div class="bars">
                  <span *ngFor="let b of [35,52,44,68,60,76,58,80,72,88,70,92]" [style.height.%]="b"></span>
                </div>
              </div>
            </div>
          </div>

          <div class="glow"></div>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .hero{
      position:relative;
      overflow:hidden;
      padding: 72px 0 0;
    }

    .hero__bg{
      position:absolute;
      inset:-40%;
      background:
        radial-gradient(900px 560px at 20% 20%, rgba(79,125,255,.30), transparent 62%),
        radial-gradient(900px 560px at 80% 30%, rgba(0,229,168,.22), transparent 62%),
        radial-gradient(900px 560px at 55% 90%, rgba(168,85,247,.16), transparent 62%),
        repeating-linear-gradient(90deg, rgba(255,255,255,.05) 0px, rgba(255,255,255,.05) 1px, transparent 1px, transparent 64px),
        repeating-linear-gradient(180deg, rgba(255,255,255,.035) 0px, rgba(255,255,255,.035) 1px, transparent 1px, transparent 64px);
      opacity:.95;
      pointer-events:none;
      transform: translateZ(0);
      animation: drift 14s ease-in-out infinite;
      z-index:-1;
    }

    @keyframes drift{
      0%,100%{ transform: translate3d(0,0,0) scale(1); }
      50%{ transform: translate3d(0,-18px,0) scale(1.02); }
    }

    .hero__grid{
      display:grid;
      grid-template-columns: 1.05fr .95fr;
      gap: 34px;
      align-items:center;
    }

    .pill{
      display:inline-flex;
      padding: 8px 12px;
      border-radius: 999px;
      border: 1px solid rgba(255,255,255,.14);
      background: rgba(255,255,255,.06);
      color: rgba(235,240,255,.85);
      font-weight: 900;
      font-size: 12px;
      letter-spacing: .3px;
    }

    .actions{
      display:flex;
      gap: 12px;
      margin-top: 22px;
      flex-wrap:wrap;
    }

    /* KPI grid (home KPIs) */
    .kpis{
      margin-top: 18px;
      display:grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 12px;
    }

    .kpi{
      border-radius: 18px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
      padding: 12px;
      box-shadow: 0 24px 80px rgba(0,0,0,.25);
    }

    .kpi__top{ display:flex; align-items:center; justify-content:space-between; gap:10px; }
    .kpi__icon{ opacity:.95; }
    .kpi b{ font-size: 18px; }
    .kpi__lab{ margin-top: 6px; color: rgba(235,240,255,.68); font-weight: 800; font-size: 12px; }

    /* Dashboard visual (desktop only) */
    .hero__visual{ position:relative; }
    .frame{
      border-radius: 26px;
      border: 1px solid rgba(255,255,255,.14);
      background: rgba(255,255,255,.06);
      box-shadow: 0 30px 90px rgba(0,0,0,.45);
      overflow:hidden;
    }
    .glow{
      position:absolute;
      inset:-30px;
      z-index:-1;
      background:
        radial-gradient(circle at 30% 30%, rgba(79,125,255,.24), transparent 55%),
        radial-gradient(circle at 70% 70%, rgba(0,229,168,.20), transparent 55%);
      filter: blur(18px);
    }

    .mock{ color: rgba(235,240,255,.92); }
    .mock__top{
      display:flex; align-items:center; gap:8px;
      padding:12px 14px;
      border-bottom:1px solid rgba(255,255,255,.10);
      background: rgba(7,11,23,.25);
    }
    .dot{ width:10px; height:10px; border-radius:999px; display:inline-block; }
    .dot.r{ background:#ff5f56; } .dot.y{ background:#ffbd2e; } .dot.g{ background:#27c93f; }
    .mock__title{ margin-left:6px; font-size:12px; font-weight:800; color: rgba(235,240,255,.72); }

    .mock__body{ padding:14px; display:grid; gap:10px; }

    /* dashboard KPI cards (renamed to avoid conflict with home KPIs) */
    .dkpi{
      display:grid;
      grid-template-columns: 1fr auto auto;
      gap:10px;
      align-items:baseline;
      padding:12px;
      border-radius:16px;
      border:1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
    }
    .dkpi span{ font-size:12px; font-weight:800; color: rgba(235,240,255,.70); }
    .dkpi b{ font-weight:1000; }
    .dkpi i{ font-style:normal; font-size:12px; font-weight:900; }
    .dkpi .up{ color:#34d399; } .dkpi .down{ color:#fb7185; }

    .bars{
      height:92px;
      display:flex;
      align-items:flex-end;
      gap:8px;
      padding:12px;
      border-radius:18px;
      border:1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
    }
    .bars span{
      flex:1;
      border-radius:12px 12px 6px 6px;
      background: linear-gradient(180deg, rgba(79,125,255,.95), rgba(0,229,168,.55));
      opacity:.9;
    }

    /* ✅ Tablet + phone */
    @media (max-width: 960px){
      .hero{ padding-top: 52px; }
      .hero__grid{
        grid-template-columns: 1fr;
        gap: 18px;
        align-items:stretch;
      }

      /* hide dashboard completely on small screens */
      .hero__visual{ display:none; }

      .kpis{ grid-template-columns: repeat(2, 1fr); }
    }

    @media (max-width: 560px){
      .hero{ padding: 44px 0 0; }
      .kpis{ gap: 10px; margin-top: 16px; }

      .kpi{
        padding: 11px 12px;
        border-radius: 16px;
      }
      .kpi b{ font-size: 16px; }
      .kpi__lab{ font-size: 11px; }

      /* optional: make buttons full width on phone */
      /* .actions .btn{ width:100%; } */
    }

    @media (prefers-reduced-motion: reduce){
      .hero__bg{ animation:none; }
    }
  `]
})
export class HeroComponent {}
